<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="キャンセル情報"
        :ok-only="true"
        ok-title="閉じる"
        ok-variant="yokumiru-gray"
        @hidden="close">
        <div v-if="consultation !== null">
            <div class="card mb-3">
                <div class="card-header font-weight-bold">{{ cancelModelName }}によるキャンセル事由</div>
                <div class="card-body">
                    <div class="cancelReasonWrapper">
                        <div v-if="!hasReason && isCausedByDoctor" class="hasNoReason text-center text-danger">キャンセル事由未回答</div>
                        <div v-else-if="!hasReason" class="text-muted">回答なし</div>
                        <div v-else-if="!hasReasonDetail">{{ consultation.cancel_reason }}</div>
                        <div v-else>
                            <div class="reasonSection">
                                <div class="reasonTitle">キャンセル事由を選択してください。</div>
                                <div class="reasonContent">{{ consultation.cancel_reason }}</div>
                            </div>
                            <div class="reasonSection">
                                <div class="reasonTitle">キャンセル事由の詳細を記入してください。</div>
                                <div class="reasonContent">{{ consultation.consultation_cancel_detail.cancel_reason_detail ? consultation.consultation_cancel_detail.cancel_reason_detail : '-' }}</div>
                            </div>
                            <div class="reasonSection">
                                <div class="reasonTitle">今回の{{ $locale.consultation_host }}を予約された会員様へお伝えすることがあればご記入ください。</div>
                                <div class="reasonContent">{{ consultation.consultation_cancel_detail.message_to_user ? consultation.consultation_cancel_detail.message_to_user : '-' }}</div>
                            </div>
                            <div class="reasonSection">
                                <div class="reasonTitle">今後同様の理由でのキャンセルを避けるための対策はありますか？</div>
                                <div class="reasonContent">{{ consultation.consultation_cancel_detail.prevention_measures ? consultation.consultation_cancel_detail.prevention_measures : '-' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import constants from '../../../constants'

export default {
    data: function () {
        return {
            consultation: null,
            modalShow: false,
        }
    },

    computed: {
        /**
         * 医師によるキャンセル or 未入室終了かどうか
         * @return {*|boolean}
         */
        isCausedByDoctor: function () {
            if (this.consultation === null) return false
            return this.consultation.flg_cancel_by_doctor
                || this.consultation.status === constants.consultations.absenceDoctor
        },

        /**
         * @return {string}
         */
        cancelModelName: function () {
            return this.isCausedByDoctor ? '医師' : this.$locale.patient
        },

        /**
         * キャンセル事由が入力済みかどうか
         * @return {boolean}
         */
         hasReason: function () {
            if (this.consultation === null) return false
            return this.consultation.cancel_reason !== void(0)
                && this.consultation.cancel_reason !== null
        },

        /**
         * キャンセル事由の詳細情報が入力済みかどうか
         * @return {boolean}
         */
        hasReasonDetail: function () {
            if (this.consultation === null) return false
            return this.consultation.consultation_cancel_detail !== null
        }
    },

    created: function() {
        bus.$on('open-modal-consultation-cancel-info-modal', this.open)
    },

    beforeDestroy: function() {
        bus.$off('open-modal-consultation-cancel-info-modal')
    },

    methods: {
        /**
         * モーダルを表示
         * @param {object} consultation
         */
        open: function(consultation) {
            this.consultation = consultation
            this.modalShow = true
        },

        /**
         * モーダルを閉じる
         */
        close: function() {
            this.modalShow = false
        },
    },
}
</script>

<style lang="scss" scoped>
.cancelReasonWrapper {
    .hasNoReason {
        padding: 10px;
        background: #FFEEEE;
        border-radius: 4px;
    }

    .reasonSection {
        margin-bottom: 30px;

        &:last-child {
            margin-bottom: 0;
        }

        .reasonTitle {
            margin-bottom: 3px;
            font-weight: bold;
        }

        .reasonContent {
            white-space: pre-wrap;
            line-height: 1.5;
        }
    }
}
</style>
